import { SvgIcon, SvgIconProps } from './SvgIcon';

export const CheckIcon = (props: SvgIconProps): JSX.Element => {
  const { viewBox, ...rest } = props;
  return (
    <SvgIcon {...rest} viewBox={viewBox ?? '0 0 20 20'}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5898 6.03665C16.8457 6.36235 16.7891 6.83384 16.4634 7.08976C13.5252 9.39849 11.9217 11.0035 9.08042 14.4751C8.93662 14.6508 8.72097 14.7519 8.49394 14.75C8.2669 14.7482 8.05292 14.6436 7.912 14.4656C6.52572 12.7145 5.68486 11.8911 4.03528 10.5887C3.71018 10.332 3.65471 9.86038 3.91138 9.53528C4.16806 9.21018 4.63968 9.15471 4.96478 9.41138C6.46172 10.5933 7.35476 11.4288 8.5055 12.8147C11.0563 9.74802 12.7077 8.13319 15.5367 5.9103C15.8623 5.65439 16.3338 5.71095 16.5898 6.03665Z"
      />
    </SvgIcon>
  );
};
